import React from 'react'
import {Box} from '@mui/material'
import moment from 'moment'
import AppDialog from 'src/components-new/feedback/AppDialog'
import ReadOnlyField from 'src/components-new/inputs/ReadOnlyField'

interface WeightDetailDialogNewProps {
  open: boolean
  onClose: () => void
  detail?: Record<string, any>
}

export default function WeightDetailDialogNew({open, onClose, detail}: WeightDetailDialogNewProps): JSX.Element {
  return (
    <AppDialog open={open} onClose={onClose} title="Peso" maxWidth="sm">
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
        <ReadOnlyField label="Data" value={detail?.date ? moment(detail.date).format('DD MMM YYYY') : undefined} />
        <ReadOnlyField label="Peso" value={detail?.weight != null ? String(detail.weight) : undefined} />
      </Box>
    </AppDialog>
  )
}
